import React from "react";
import {
    Bookmark,
    Crosshair,
    DownloadCloud,
    Edit,
    FileText,
    Framer,
    Paperclip,
    Search,
    Star,
    UploadCloud
} from "react-feather";
import img_proposta from "../../imagens/mob_proposta.png";
import {CollCard, CollImg, ContainerBody, Wrapper} from "../styleMobile";
import {CardFeatures} from "../Components/CardFeatures";
import {CardHearder} from "../Components/CardHearde";

export const Proposta = ({id}) => {
    return (
        <ContainerBody id={id} background={'#5C719F'}>
            <Wrapper>
                <CardHearder
                    icon={<Paperclip size={'40px'}/>}
                    titulo={'PROPOSTA'}
                    texto={'Importe sua planilha, selecione seus documentos de habilitação e anexos da proposta e automatize o envio pro portal do comprasnet. Gerencie as propostas enviadas alterando, incluindo ou excluindo a qualquer momento.'}
                />

                <CollImg>
                    <div>
                        <img
                            src={img_proposta}
                            height={"auto"}
                            width={"100%"}
                            alt={"logo wavecode"}
                        />
                    </div>
                </CollImg>

                <CollCard>
                    <CardFeatures icon={<FileText/>} texto={"PREENCHIMENTO \n" + "RÁPIDO"}/>
                    <CardFeatures icon={<UploadCloud/>} texto={"UPLOAD "+" DE ANEXOS"}/>
                    <CardFeatures icon={<Crosshair/>} texto={"PROCESSO\n OBJETIVO"}/>
                    <CardFeatures icon={<Framer/>} texto={"CONTROLE\n FACILITADO"}/>
                </CollCard>

            </Wrapper>
        </ContainerBody>
    )
};
